import { useTranslation } from 'react-i18next';
import { SEO } from '../components/SEO';

export const LegalNotice = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen pt-16 bg-white" style={{fontFamily:'IBM Plex Sans,sans-serif'}}>
      <SEO title={`${t('legal_notice.title')} | Durable Designs`} description={t('legal_notice.title')} path="/legal" />

      <section className="bg-green-900 py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-[640px] mx-auto">
          <h1 className="text-4xl sm:text-5xl font-semibold text-white tracking-tight" style={{fontFamily:'Outfit,sans-serif'}} data-testid="legal-heading">
            {t('legal_notice.title')}
          </h1>
          <p className="text-sm text-green-300 mt-3">{t('legal_notice.subtitle')}</p>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-[640px] mx-auto prose-dd">

          <h2>{t('legal_notice.s1_title')}</h2>
          <p>{t('legal_notice.s1_p1')}</p>
          <div className="bg-gray-50 border border-gray-200 p-5 text-sm text-gray-700 leading-relaxed mb-6" data-testid="legal-company-details">
            <strong>{t('legal_notice.s1_company')}</strong> <em>{t('legal_notice.s1_type')}</em><br /><br />
            {t('legal_notice.s1_registered_name')}<br />
            {t('legal_notice.s1_address_label')} {t('legal_notice.s1_address')}<br />
            {t('legal_notice.s1_state_label')} {t('legal_notice.s1_state')}<br /><br />
            {t('legal_notice.s1_email_label')} <a href="mailto:info@durabledesigns.co.uk" className="text-green-700 hover:text-green-600">info@durabledesigns.co.uk</a><br />
            {t('legal_notice.s1_website_label')} <a href="https://durabledesigns.co.uk" target="_blank" rel="noopener noreferrer" className="text-green-700 hover:text-green-600">www.durabledesigns.co.uk</a>
          </div>

          <h2>{t('legal_notice.s2_title')}</h2>
          <p>{t('legal_notice.s2_p1')}</p>

        </div>
      </section>
    </div>
  );
};

export default LegalNotice;
